// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const dni: CountryValidator<"AR"> = createValidator(
  "ar.dni",
  7,
);

export default dni;
export const compact = dni.compact;
export const format = dni.format;
export const validate = dni.validate;
export const generate = (): string =>
  dni.generate?.() ??
  (() => {
    throw new Error(
      "Validator ar.dni cannot generate values",
    );
  })();
